import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=1a47ed2a&scoped=true"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=1a47ed2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47ed2a",
  null
  
)

export default component.exports